import React, { useState } from 'react';
import { Application } from '../../../../entities/Application';
import { Dropdown } from '../../../../components/Dropdown';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { PropTypes as ActionPropTypes } from '../../../../components/Dropdown/DropdownMenu/DropdownAction';
import { AddScorecardModal } from './AddScorecardModal';
import { CandidateRatingModal } from '../../../../components/ApplicantTracking/CandidateRatingModal';

interface PropTypes {
  application: Application;
  isLoading: boolean;
  refreshList: () => void;
}

function addScorecard(action: () => void): ActionPropTypes {
  return {
    action: () => action(),
    buttonChild: (
      <span className='px-2h text-info'>Fill in Ad-hoc Scorecard</span>
    ),
  };
}

function addCandidateRating(action: () => void): ActionPropTypes {
  return {
    action: () => action(),
    buttonChild: <span className='px-2h text-info'>Add Candidate Rating</span>,
  };
}

export function AddFeedback(props: PropTypes) {
  const [scorecardModalOpen, setScorecardModalOpen] = useState(false);
  const [candidateRatingModalOpen, setCandidateRatingModalOpen] =
    useState(false);

  const menuActions = [addScorecard(() => setScorecardModalOpen(true))];

  if (props.application.createRatingEnabled) {
    menuActions.push(
      addCandidateRating(() => setCandidateRatingModalOpen(true)),
    );
  }

  return (
    <div>
      <Dropdown
        buttonIcon={{
          name: 'bi-plus-circle',
          className: props.isLoading && 'disabled',
        }}
        buttonText='Add Feedback'
        buttonClassName={classNames(
          'bg-blue text-white px-2h',
          styles['add-feedback-button'],
        )}
        menuPlacementClass='dropdown-menu-end'
        menuActions={menuActions}
      />

      <AddScorecardModal
        application={props.application}
        isOpen={scorecardModalOpen}
        onClose={() => setScorecardModalOpen(false)}
      />
      <CandidateRatingModal
        application={props.application}
        isOpen={candidateRatingModalOpen}
        onClose={() => {
          props.refreshList();
          setCandidateRatingModalOpen(false);
        }}
      />
    </div>
  );
}
